import React from "react";
import Logo from "./Logo";

interface Props {
    date: Date;
    venue: string;
    onShowStats: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

export default function Sidebar({ date, venue, onShowStats }: Props): JSX.Element {
    return (
        <>
            <div className="flex justify-center">
                <Logo className="w-4/5" />
            </div>
            <h1 className="text-center text-xl font-medium">
                {date.toLocaleDateString()}
            </h1>
            <h2 className="text-center text-xl font-medium">
                {venue}
            </h2>
            <div className="flex grow items-end">
                <button
                    type="button"
                    className={"-ml-4 flex h-2/3 w-1/3 items-center justify-center"
                    + " rounded-r-lg bg-shamrock-400 p-4 text-2xl font-bold"}
                    onClick={onShowStats}
                >
                    <p className="text-blue-zodiac-950" style={{ writingMode: "vertical-rl" }}>Match Stats</p>
                </button>
            </div>
        </>
    );
}
